import { ServerStatus, ServerStatusReq, ServerStatusResponse } from "common247";
import { FirebaseServices } from "./config";
import { callFunction } from "./helpers";

export async function getServerStatus(fb: FirebaseServices): Promise<ServerStatus> {
  const result = await callFunction<ServerStatusReq, ServerStatusResponse>(fb, "getServerStatusFunc", {});
  console.log("Server Status:", result.serverStatus);
  return result.serverStatus;
}
